import type { CollectionsQuery } from '~/generated/graphql';
import { BentoGrid } from './BentoGrid';

type VariantType =
  CollectionsQuery['collections']['items'][number]['productVariants']['items'][number];

interface CollectionBentoGridProps {
  variants: VariantType[];
  collectionName: string;
}

export function CollectionBentoGrid({
  variants,
  collectionName,
}: CollectionBentoGridProps) {
  if (!variants || variants.length === 0) return null;

  return <BentoGrid variants={variants} collectionName={collectionName} />;
}
